import { Box, Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled, ParentSelectBox } from './PresentingComplaintSection'
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector'
import { onTreatmentOpt, pastHistoryComborbidityOpt, past_ocular_history_options, rednessLeftOptions, treatmentTypeOption } from './formOptions'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController'
import { CustomInputLable, InputContainer, ParentContainerSection } from '../DiabeticForm'
import InputController from '../../../../components/InputController/InputController'

const FocusedHistory = (props) => {
    const {control, errors, watch} = props
  return (
    <>
         <ParentContainerSection  heading="Section C - Focused History">


<InputContainer >
 <CustomInputLable required >Past Ocular History</CustomInputLable>
 <RadioButtonController
   name="focused_past_ocular_history"
   control={control}
   errors={errors}
   options={past_ocular_history_options}
   isRow
   isDisabled
 />
</InputContainer>

{watch("focused_past_ocular_history") === "1" && <InputContainer>
 <CustomInputLable>If Yes (specify)</CustomInputLable>
 <InputController
   name="focused_past_ocular_history_comment"
   control={control}
   errors={errors}
   size="small"
   comment
   fullWidth
   isDisabled
 />
</InputContainer>}

<InputContainer>
 <CustomInputLable required>Are you on treatment</CustomInputLable>
 <RadioButtonController
     name="on_treatment"
   control={control}
   errors={errors}
   options={onTreatmentOpt}
   isDisabled
   isRow
 />
</InputContainer>

{watch("on_treatment") === "1" && <InputContainer>
 <CustomInputLable>If Yes</CustomInputLable>
 <CheckboxController
   name={"treatment_type"}
   isRow={true}
   isMultiCheckbox={true}
   control={control}
   errors={errors}
   options={treatmentTypeOption}
   isHorizantalPadding={true}
   isCustomPadding
   isDisabled
   size="small"
 />
</InputContainer>}

<CustomInputLable required style={{ marginBottom:"1rem"}}>Past Medical History and Comorbidity</CustomInputLable>
<InputContainer sx={{ marginLeft: "10px !important" }}>
 <CheckboxController
    name="pasthistory_comborbidity"
   isRow={true}
   isMultiCheckbox={true}
   control={control}
   errors={errors}
   options={pastHistoryComborbidityOpt}
   isHorizantalPadding={true}
   isDisabled
   size="small"
 />
</InputContainer>
   </ParentContainerSection>
    </>
  )
}

export default FocusedHistory